import Vue from "vue";
import Router from "vue-router";
import Consumption from "@/views/Consumption"
import SimCard from "@/views/SimCard"
import BundleServices from "@/views/BundleServices"
import MobileMoney from "@/views/MobileMoney"
import MTNBusiness from "@/views/MTNBusiness"
import Home from "@/views/Home"
import SearchSomething from '@/views/SearchSomething'
Vue.use(Router);
const routes = [
  {
    path: "/business/",
    name: "ebu_home",
    component: MTNBusiness,
    meta: {
      auth: true,
      title: 'MTN Business',
      single: false,
      top_menu: "consumption",
    }
  },
  {
    path: "/momo/",
    name: "momo_home",
    component: MobileMoney,
    meta: {
      auth: true,
      title: 'Mobile Money',
      single: false,
      top_menu: "consumption",
    }
  },
  {
    path: "/forfaits-services/",
    name: "bundle_services",
    component: BundleServices,
    meta: {
      auth: true,
      title: 'Forfaits & services',
      single: false,
      top_menu: "consumption",
    }
  },
  {
    path: "/consommation/",
    name: "consumption",
    component: Consumption,
    meta: {
      auth: true,
      title: 'Ma Consommation',
      single: false,
      top_menu: "consumption",
    }
  },
  {
    path: "/carte-sim/",
    name: "sim-card",
    component: SimCard,
    meta: {
      auth: true,
      title: 'Gérer ma carte SIM',
      single: false,
      top_menu: "consumption",
    }
  },
  
  {
    path: "/",
    name: "home",
    meta: {
      auth: false,
      title: 'Mon Compte', 
      single: false
    },
    component: Home,
  },
  {
    path: "/search",
    name: "search",
    meta: {
      auth: false,
      title: 'Recherche', 
      single: false
    },
    component: SearchSomething,
  },
  
];

var router = new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    window.scrollTo(0,0);
  }
});

export default router;
